const toggle = () => {
  const toggle = document.querySelector(".toggle");
  if (!toggle) return;

  const checkbox = toggle.querySelector("input");
  const numbers = document.querySelectorAll(".banner-number");

  checkbox.addEventListener("change", () => {
    toggle.classList.toggle("is-audited");
    for (const number of numbers) {
      number.classList.toggle("is-audited");
    }
  });
};

export default toggle;
